import { SystemEntity } from '@erp/shared-types';

export type EntityReferencePickerKind = 'supplier' | 'customer' | 'record';

export type EntityReferenceCommit =
  | { kind: 'skip' }
  | { kind: 'clear' }
  | { kind: 'set'; entityType: SystemEntity; entityId: string };

/** Which search control an entity-reference field can edit with. */
export function entityReferencePicker(
  entityType: SystemEntity | null,
): EntityReferencePickerKind {
  if (entityType === SystemEntity.AP_SUPPLIER) return 'supplier';
  if (entityType === SystemEntity.AR_CUSTOMER) return 'customer';
  return 'record';
}

/**
 * What an edit should write. `skip` means the pick did not change the id,
 * or there is no entity type to store.
 */
export function entityReferenceCommit(
  entityType: SystemEntity | null,
  currentId: string | null,
  nextId: string | null,
): EntityReferenceCommit {
  if (nextId === currentId || !entityType) return { kind: 'skip' };
  if (!nextId) return { kind: 'clear' };
  return { kind: 'set', entityType, entityId: nextId };
}
